import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-main\",\"display\":\"swap\",\"preload\":true}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/components/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/global.scss");
